<template>
  <div class="row">
    <div class="col col-8">
      <component :is="$store.state.calculators.calculator" />
    </div>
    <Navigation articles />
  </div>
</template>

<script>
import Navigation from '../../Navigation';
import ConfidenceInterval from './ConfidenceInterval.vue';
import MeanMedianMode from './MeanMedianMode.vue';
import Skewness from './Skewness.vue';
import Kurtosis from './Kurtosis.vue';
import StandardDeviation from './StandardDeviation.vue';
import Variance from './Variance.vue';
import CoefficientOfVariation from './CoefficientOfVariation.vue';
import LinearRegression from './LinearRegression.vue';
import PValue from './PValue.vue';
import HypothesisTest from './HypothesisTest.vue';
import DifferenceInMeans from './DifferenceInMeans.vue';

export default {
  components: {
    Navigation,
    ConfidenceInterval,
    MeanMedianMode,
    Skewness,
    Kurtosis,
    StandardDeviation,
    Variance,
    CoefficientOfVariation,
    LinearRegression,
    PValue,
    HypothesisTest,
    DifferenceInMeans,
  },
};
</script>

<style lang="scss" scoped>
.row {
  margin-top: var(--spacing-140);
}

@include bp($bp-mobile) {
  .row {
    margin-top: 0;
    padding: 0 var(--spacing-24) var(--spacing-100);

    ::v-deep .articles-container {
      .h3,
      .h4 {
        margin-bottom: var(--spacing-32);
      }

      .h3 {
        font-size: 24px;
      }

      .h4 {
        font-size: 21px;
      }

      .introduction {
        margin-top: 0;
      }

      .heading2 {
        margin-top: var(--spacing-40);
      }

      .formulas {
        margin: var(--spacing-16) 0;

        &.confidence-interval {
          margin-top: 34px;
        }
      }
    }

    .col.col-4::v-deep {
      margin-bottom: 0;

      &.nav-bottom-margin {
        margin-bottom: 0;
      }
    }
  }
}
</style>
